module.exports = __webpack_public_path__ + "img/erweima.efe41895.png";